import { MbeUser } from '@/components/icons';
import { LoggedUserAvatar } from '@/components/shared';
import { LanguageSelector } from '@/components/shared/LanguageSelector';
import { useAuth } from '@/hooks';
import { Center, Divider, Flex, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const UserMenu = (): JSX.Element => {
  const { authUser } = useAuth();
  const { t } = useTranslation();

  return (
    <Flex alignItems="center">
      {authUser ? (
        <LoggedUserAvatar />
      ) : (
        <Link alignItems="center" as="a" display="inline-flex" gap={2} href="/login">
          <MbeUser h={8} w={8} />
          <Text
            display={{ base: 'none', lg: 'inline-block' }}
            fontSize="medium"
            textTransform="uppercase"
          >
            {t('LANDING.MENU.SIGN_IN')}
          </Text>
        </Link>
      )}
      <Center display={{ base: 'none', md: 'block' }} height="40px" ml={7} mr={2}>
        <Divider borderColor="white" orientation="vertical" />
      </Center>
      <LanguageSelector />
    </Flex>
  );
};
